import type { User, UserProfile } from '@/common/user.common'

export function getUserDisplayName(user?: User | null, profile?: UserProfile | null) {
  const first = profile?.firstName?.trim() ?? ''
  const last = profile?.lastName?.trim() ?? ''
  const fullName = `${first} ${last}`.trim()

  return fullName || user?.displayName || ''
}

export function triggerBlobDownload(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}
